import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/lib/date-picker/style/index';

export const DatePicker = generatePicker(dayjsGenerateConfig);
